import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import AltRouteIcon from "@mui/icons-material/AltRoute";
import { buscarQtdSolicitacaoPorUsuario } from "../../../../services/api-planejamento-tributario.service";
import { useNavigate } from "react-router-dom";
import ModalSolicitacoes from "./ModalSolicitacoes";
import MensagemErro from "../../../../components/MensagemErro";
import Loading from "../../../../components/Loading";

const SolicitacoesWorkflow = () => {
  const [qtd, setQtd] = useState({
    qtdMeusAprovados: 0,
    qtdMeusPendentes: 0,
    qtdMeusReprovados: 0,
    qtdTotal: 0,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState("");
  const [title, setTitle] = useState("");
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await buscarQtdSolicitacaoPorUsuario();
        if (response && typeof response === "object") {
          setQtd((prev) => ({ ...prev, ...response }));
        }
      } catch (error) {
        const d = error?.response?.data;
        setMsg(
          d?.mensagem ||
            d?.erro ||
            error?.message ||
            "Erro de conexão. Verifique se a API de planejamento tributário está rodando."
        );
        setOpenSnackbarErro(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleOpenModal = (statusSolicitacao, titulo) => {
    setStatus(statusSolicitacao);
    setTitle(titulo);
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setStatus("");
    setOpenModal(false);
  };

  const handleNavigate = (tipo) => {
    if (tipo !== "T") {
      navigate(`/gestao/solicitacoes?tipo=${tipo}`);
    } else {
      navigate(`/gestao/solicitacoes`);
    }
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <AltRouteIcon sx={{ marginRight: ".5rem" }} /> Solicitações em
          Workflow
        </div>
        <div className={styles.content}>
          {loading ? (
            // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loading loading={loading} />
            // </div>
          ) : (
            <ul className={styles.list}>
              <li
                onClick={() =>
                  handleOpenModal("PENDENTES", "Minhas pendências")
                }
              >
                Minhas pendências <span>{qtd.qtdMeusPendentes}</span>
              </li>
              <li
                onClick={() =>
                  handleOpenModal("APROVADAS", "Aprovadas por mim")
                }
              >
                Aprovadas por mim <span>{qtd.qtdMeusAprovados}</span>
              </li>
              <li
                onClick={() =>
                  handleOpenModal("REPROVADAS", "Reprovadas por mim")
                }
              >
                Reprovadas por mim<span>{qtd.qtdMeusReprovados}</span>
              </li>
              <li onClick={() => handleNavigate("T")}>
                Todas solicitações<span>{qtd.qtdTotal}</span>
              </li>
            </ul>
          )}
        </div>
      </div>
      <ModalSolicitacoes
        open={openModal}
        onClose={handleCloseModal}
        status={status}
        title={title}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </>
  );
};

export default SolicitacoesWorkflow;
